import { IAppState } from '../../../../AppModulesWrapper';

import { selectIsSubagent } from '../../user';
import { selectPlacingMoneySource } from '../../../reducers/v2/moneySources/selectors';
import { EMoneySource } from '../../../types/reducers/user';
import { EPlacingType } from '../../../types/reducers/publishTerms';
import { selectActivePlacingType } from '../../../reducers/v2/paidPublication/selectors';

export const selectIsChangePackageDisable = (state: IAppState): boolean => {
  const isSubagent = selectIsSubagent(state);
  const placingMoneySource = selectPlacingMoneySource(state);
  const activePlacingType = selectActivePlacingType(state);

  return isSubagent && placingMoneySource === EMoneySource.Self && activePlacingType === EPlacingType.package;
};
